/** DeepGaming brand tokens, same values as www.deepgaming.eu. */
export const BRAND = {
  plum: '#42145b',
  plumDeep: '#2d0b40',
  plumSoft: '#8a4fb0',
  plumTint: '#f6f1fa',
  yellow: '#ffcd40',
  yellowDeep: '#e0ab14',
  ink: '#1c1324',
  fontSans: "'Roboto', system-ui, -apple-system, 'Segoe UI', sans-serif",
  fontDisplay: "'Roboto Condensed', 'Roboto', 'Arial Narrow', sans-serif",
} as const
